import type { Config } from "wagmi"

import type { IEventBus } from "@/domains/events"
import type { IWithdrawLock } from "@/domains/lock-page/withdraw-store"
import { WithdrawOrchestrator } from "@/domains/lock-page/withdraw-orchestrator"
import { WithdrawStore } from "@/domains/lock-page/withdraw-store"
import { WalletConnectionStore } from "@/domains/wallet"

export class WithdrawOrchestratorFactory {
  /**
   * Creates a new WithdrawOrchestrator with all required dependencies
   *
   * @param chainId - Chain ID for blockchain interactions
   * @param config - Wagmi config for blockchain interactions
   * @param lock - Lock store or compatible interface
   * @param eventBus - Event bus for publishing domain events
   * @param voterAddress - Voter contract address for reset operations
   * @param vestedAddress - Vested token contract address for withdraw operations
   * @param walletStore - Wallet connection store for getting current address in real-time
   * @returns Configured WithdrawOrchestrator instance
   */
  static create(
    chainId: number,
    config: Config,
    lock: IWithdrawLock | null,
    eventBus: IEventBus,
    voterAddress: `0x${string}`,
    vestedAddress: `0x${string}`,
    walletStore: WalletConnectionStore,
  ): WithdrawOrchestrator {
    // Create store
    const store = new WithdrawStore({
      state: "idle",
      lock,
      resetError: null,
      withdrawError: null,
      resetTxHash: null,
      withdrawTxHash: null,
    })

    // Create orchestrator with all dependencies
    const orchestrator = new WithdrawOrchestrator(
      chainId,
      store,
      config,
      lock,
      eventBus,
      voterAddress,
      vestedAddress,
      walletStore,
    )

    return orchestrator
  }
}
